import { Title } from '../../../components'
import {
    Container
} from './styles'

export default function (){
    return (
        <Container>
            <div className="row">
                <div className="col">
                    <Title>Documentação</Title>

                    <section className="mt-2 p-3">

                        <p>
                            Axial utilizar ww 4500 e wl 500;<br/>
                            Coronal utilizar ww 4.500 e wl 500;
                        </p>
                        <p>
                            <b>Axial Osso direito -</b> 1 filme na formatação de 20 imagens;<br/>
                            <b>Axial Osso esquerdo -</b> 1 filme na formatação de 20 imagens;<br/>
                            <b>Coronal Osso direito -</b> 1 filme na formatação de 20 imagens;<br/>
                            <b>Coronal Osso esquerdo -</b> 1 filme na formatação de 20 imagens;<br/>
                        </p>

                        <p>
                            <b>Impressão Mista, Filme e Papel</b><br/>
                            Axial em filme; <br/>
                            Coronal em papel;<br/>
                        </p>
                        <p>
                            <b>Impressão apenas em Papel</b><br/>
                            Axial em papel;<br/>
                            Coronal em papel;<br/>
                        </p>
                    </section>
                </div>
            </div>
        </Container>
    )
}